import colors from '../colors';

const baseVariantShared = {
  borderRadius: '5px',
  margin: '1rem 0',
  outline: 'none'
};

const chart = {
  primary: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'primary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'primary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'orange.80',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary',
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'orange.80',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary',
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary',
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondary: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  primaryAlternate: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'secondary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'secondary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'indigo.90',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary',
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'indigo.90',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'secondary',
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolgrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary',
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'secondary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondaryAlternate: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    margin: 0,
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    ['@media (min-width: 1024px)']: {
      '&::before': {
        content: '""',
        transition: 'height 0.15s ease',
        cursor: 'default',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: 0
      },
      '&.dropdownBorder': {
        '&::before': {
          height: '5px',
          bottom: '-1px'
        }
      },
      '&.navBarDropdownBorderBase': {
        '&::before': {
          content: 'unset',
          bottom: '-28px',
          height: '4px'
        }
      },
      '&.navBarDropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  filter: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: 'textOnly',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'primarySecondaryAccent'
    }
  },
  basic: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    '&:active, &:focus': {
      borderColor: 'primary'
    }
  },
  languageSwitcher: {
    background: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: '0',
    paddingLeft: 's8',
    paddingRight: 's8'
  }
};

const co = {
  primary: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'coolGrey.100',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'coolGrey.70',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'coolGrey.70',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondary: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  primaryAlternate: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'blue.60',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'blue.60',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'blue.90',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'blue.90',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'blue.60',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondaryAlternate: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'blue.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: 0,
    margin: 0,
    '&:active, &:focus': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    ['@media (min-width: 1024px)']: {
      '&::before': {
        content: '""',
        transition: 'height 0.15s ease',
        cursor: 'default',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: 0
      },
      '&.dropdownBorder': {
        '&::before': {
          height: '5px',
          bottom: '-1px'
        }
      },
      '&.navBarDropdownBorderBase': {
        '&::before': {
          content: 'unset',
          bottom: '-28px',
          height: '4px'
        }
      },
      '&.navBarDropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  filter: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: 'textOnly',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'primarySecondaryAccent'
    }
  },
  tabs: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    '&:active, &:focus': {
      borderColor: 'primary'
    }
  },
  languageSwitcher: {
    background: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: '0',
    paddingLeft: 's8',
    paddingRight: 's8'
  }
};

const edu = {
  primary: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'indigo.70',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'indigo.70',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'indigo.80',
      backgroundColor: 'indigo.20',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:focus': {
      color: 'indigo.80',
      backgroundColor: 'indigo.20',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:active': {
      color: 'indigo.80',
      backgroundColor: 'indigo.20',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'indigo.70',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondary: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  primaryAlternate: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'indigo.70',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'indigo.70',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'indigo.80',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'indigo.80',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'indigo.70',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondaryAlternate: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.70'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    color: 'coolGrey.90',
    margin: 0,
    '&:active, &:focus': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    ['@media (min-width: 1024px)']: {
      '&::before': {
        content: '""',
        transition: 'height 0.15s ease',
        cursor: 'default',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: 0
      },
      '&.dropdownBorder': {
        '&::before': {
          height: '5px',
          bottom: '-1px'
        }
      },
      '&.navBarDropdownBorderBase': {
        '&::before': {
          content: 'unset',
          bottom: '-28px',
          height: '4px'
        }
      },
      '&.navBarDropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  filter: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: 'textOnly',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'primarySecondaryAccent'
    }
  },
  tabs: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    '&:active, &:focus': {
      borderColor: 'primary'
    }
  },
  languageSwitcher: {
    background: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: '0',
    paddingLeft: 's8',
    paddingRight: 's8'
  }
};

const scale = {
  primary: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'primary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'primary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'primaryAccent',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'primaryAccent',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondary: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  primaryAlternate: {
    ...baseVariantShared,
    color: 'black',
    backgroundColor: 'secondary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'secondary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'black',
      backgroundColor: 'yellow.25',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:focus': {
      color: 'black',
      backgroundColor: 'yellow.25',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'yellow.25'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'black',
      backgroundColor: 'secondary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondaryAlternate: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: 0,
    margin: 0,
    '&:active, &:focus': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    ['@media (min-width: 1024px)']: {
      '&::before': {
        content: '""',
        transition: 'height 0.15s ease',
        cursor: 'default',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: 0
      },
      '&.dropdownBorder': {
        '&::before': {
          height: '5px',
          bottom: '-1px'
        }
      },
      '&.navBarDropdownBorderBase': {
        '&::before': {
          content: 'unset',
          bottom: '-28px',
          height: '4px'
        }
      },
      '&.navBarDropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  filter: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: 'textOnly',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'primarySecondaryAccent'
    }
  },
  tabs: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    '&:active, &:focus': {
      borderColor: 'primary'
    }
  },
  languageSwitcher: {
    background: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: '0',
    paddingLeft: 's8',
    paddingRight: 's8'
  }
};

const spark = {
  primary: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'primary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'primary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'primaryAccent',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'primaryAccent',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondary: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'primary'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  primaryAlternate: {
    ...baseVariantShared,
    color: 'white',
    backgroundColor: 'secondary',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'secondary',
    boxShadow: `4px 4px 0 0 ${colors.coolGrey[10]}`,
    '&:hover': {
      color: 'white',
      backgroundColor: 'indigo.60',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:focus': {
      color: 'white',
      backgroundColor: 'indigo.60',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'secondary'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'white',
      backgroundColor: 'secondary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  secondaryAlternate: {
    ...baseVariantShared,
    color: 'coolGrey.100',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    '&:hover': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100'
    },
    '&:focus': {
      color: 'coolGrey.100',
      backgroundColor: 'coolGrey.5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'indigo.60'
    },
    '&:active': {
      color: 'white',
      backgroundColor: 'coolGrey.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'indigo.60'
    },
    '&:disabled, &[aria-disabled="true"]': {
      color: 'coolGrey.100',
      backgroundColor: 'white',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.100',
      boxShadow: 'none',
      cursor: 'default',
      opacity: '0.35'
    }
  },
  navLink: {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: 0,
    margin: 0,
    '&:active, &:focus': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'coolGrey.90',
      textDecoration: 'none'
    },
    ['@media (min-width: 1024px)']: {
      '&::before': {
        content: '""',
        transition: 'height 0.15s ease',
        cursor: 'default',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: 0
      },
      '&.dropdownBorder': {
        '&::before': {
          height: '5px',
          bottom: '-1px'
        }
      },
      '&.navBarDropdownBorderBase': {
        '&::before': {
          content: 'unset',
          bottom: '-28px',
          height: '4px'
        }
      },
      '&.navBarDropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  filter: {
    backgroundColor: 'white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'coolGrey.100',
    borderRadius: 'textOnly',
    color: 'coolGrey.100',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'primarySecondaryAccent',
      color: 'coolGrey.100'
    }
  },
  basic: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    '&:active, &:focus': {
      borderColor: 'primary'
    }
  },
  languageSwitcher: {
    background: 'transparent',
    color: 'coolGrey.90',
    border: 'none',
    padding: '0',
    paddingLeft: 's8',
    paddingRight: 's8'
  }
};

const buttons = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    scale,
    spark
  }
};

export type ButtonVariantsType = 'primary'
| 'secondary'
| 'primaryAlternate'
| 'secondaryAlternate'
| 'navLink'
| 'filter'
| 'basic'
| 'tabs'
| 'languageSwitcher';

export const buttonVariants = Object.keys(chart) as ButtonVariantsType[];

export default buttons;
